import { __, sprintf } from "@wordpress/i18n";
import parse from "html-react-parser";
import { useContext } from "react";
import { ReactComponent as Loader } from "../../assets/loader.svg";
import { useRef, useState } from "react";
import { ajaxCall } from "../../Helpers/AjaxHelper";
import { SettingsContext } from "../../Settings";

const CheckConnection = () => {
  const [isChecking, setIsChecking] = useState(false);
  const [checkStatus, setCheckStatus] = useState(null);
  const checkConnection = () => {
    setIsChecking(true);
    ajaxCall("sby_check_connection")
      .then((res) => {
        return res.json();
      })
      .then(({ data }) => {
        setCheckStatus(data.hasError === false);
        setTimeout(() => {
          setCheckStatus(null);
        }, 2000);
      })
      .finally(() => {
        setIsChecking(false);
      });
  };
  return (
    <>
      {!isChecking && null === checkStatus && (
        <span onClick={checkConnection} className="test-connection">
          {__("Test Connection", "feeds-for-youtube")}
        </span>
      )}

      {isChecking && (
        <span className="test-connection loading">
          <Loader />
        </span>
      )}

      {true === checkStatus && (
        <span className="test-connection success">
          <i className="fa fa-check-circle" />{" "}
          {__("Connection successful", "feeds-for-youtube")}
        </span>
      )}

      {false === checkStatus && (
        <span className="test-connection error">
          <i className="fa fa-times-circle" />{" "}
          {__("Connection failed", "feeds-for-youtube")}
          <a href="#">{__("View error", "feeds-for-youtube")}</a>
        </span>
      )}
    </>
  );
};

const LicenseActionButton = ({
  isLicenseActive,
  licenseField,
  setLicenseStatus,
  setLicenseData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <button
      onClick={() => {
        setIsLoading(true);
        ajaxCall(
          window.sby_settings.sbyIsPro
            ? isLicenseActive()
              ? "sby_license_deactivation"
              : "sby_license_activation"
            : "sby_maybe_upgrade_redirect",
          {
            license_key: licenseField.current.value,
          }
        )
          .then((res) => {
            return res.json();
          })
          .then(({ data }) => {
            if (window.sby_settings.sbyIsPro) {
              setLicenseStatus(data.licenseStatus);
              setLicenseData(data.licenseData);
              window.sby_settings.licenseData = data.licenseData;
              // Remove license notices
              window
                .jQuery(
                  ".sby_get_pro_highlight, .sby_get_cff, .sby_get_sbi, .sby_get_ctf"
                )
                .closest("li")
                .remove();
              window.sby_settings.isLicenseInactive = false;
              document.querySelector(".sby-license-inactive-agp").remove();
            } else {
              if (data.url) {
                window.location.href = data.url;
              }
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      }}
      type="button"
      className={`sby-btn ${
        !isLicenseActive() ? "sb-btn-blue" : "sb-btn-grey"
      } ${isLicenseActive() && isLoading ? "loading" : ""}`}
    >
      {isLoading && <Loader />}
      {!isLicenseActive()
        ? __("Activate", "feeds-for-youtube")
        : __("Deactivate", "feeds-for-youtube")}
    </button>
  );
};

const LicenseSection = () => {
  const { sbyIsPro } = useContext(SettingsContext);
  const licenseFieldRef = useRef();
  const [licenseStatus, setLicenseStatus] = useState(
    window.sby_settings.licenseStatus
  );
  const [licenseData, setLicenseData] = useState(
    window.sby_settings.licenseData
  );
  const [licenseKey] = useState(window.sby_settings.licenseKey);

  const statusText = {
    valid: "Active!",
    inactive: "Inactive!",
    invalid: "Invalid!",
  };

  const isLicenseActive = () => {
    return (
      licenseStatus === "valid" ||
      licenseStatus === "active" ||
      licenseStatus === "activated"
    );
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (params.page === "youtube-feed-settings" && params.focus === "license") {
    let licenseSection = null;
    setTimeout(() => {
      licenseSection = document.querySelector(
        ".sb-tab-content .sb-tab-box.sb-license-box"
      );
      licenseSection.classList.add("sb-focus-box-section");
    }, 100);

    setTimeout(() => {
      licenseSection.classList.remove("sb-focus-box-section");
    }, 2100);
  }

  const licenseUpgradeText =
    "<p className='sby-license-upgrade-text'>" +
    sprintf(
      __(
        "<span>You are using Lite version of the plugin–no license needed. Enjoy! 🙂 To unlock more features, consider <a href='%s' target='_blank'>Upgrading to Pro</a></span>",
        "feeds-for-youtube"
      ),
      window.sby_settings.upgradeUrl
    ) +
    "<em>As a valued user of our Lite plugin, you receive a 50% OFF, automatically applied at checkout!</em>" +
    "</p>";

  return (
    <div>
      <div className="sb-tab-box sb-license-box clearfix">
        <div className="tab-label">
          <h3>{__("License Key", "feeds-for-youtube")}</h3>
          <p>
            {__(
              "Your license key provides access to updates and support",
              "feeds-for-youtube"
            )}
          </p>
        </div>
        <div className="sby-tab-form-field d-flex">
          <div
            className={`sby-tab-field-inner-wrap sby-license license-${licenseStatus}`}
          >
            {sbyIsPro ? "" : parse(licenseUpgradeText)}
            <span className="license-status">
              {sbyIsPro
                ? parse(
                    sprintf(
                      __(
                        "Your <strong>YouTube Feed Pro</strong> license is %s",
                        "feeds-for-youtube"
                      ),
                      statusText[licenseStatus]
                    )
                  )
                : parse(
                    __(
                      "<em>Already purchased? Simply enter your license key below to activate YouTube Feeds Pro.</em>",
                      "feeds-for-youtube"
                    )
                  )}
            </span>
            <div className="d-flex">
              <div className="field-left-content">
                <div className="sb-form-field">
                  <input
                    ref={licenseFieldRef}
                    type="password"
                    name="license-key"
                    id="license-key"
                    className="sby-form-field"
                    defaultValue={licenseKey}
                    placeholder={__("Enter License Key", "feeds-for-youtube")}
                  />
                  {licenseStatus === "valid" && (
                    <span className="field-icon fa fa-check-circle" />
                  )}
                  {licenseData.errorMsg && (
                    <span className="field-icon field-icon-error fa fa-times-circle" />
                  )}
                </div>
                {licenseData.errorMsg && (
                  <div className="mb-6">
                    <span className="sby-error-text">
                      {parse(licenseData.errorMsg)}
                    </span>
                  </div>
                )}
                <div className="form-info d-flex justify-between">
                  <span className="manage-license">
                    {isLicenseActive() && (
                      <a
                        href={window.sby_settings.manageLicense}
                        target="_blank"
                      >
                        {__("Manage License", "feeds-for-youtube")}
                      </a>
                    )}
                  </span>
                  <span>
                    <CheckConnection />
                    <span className="recheck-license-status" />
                    <span className="upgrade">
                      <a href={window.sby_settings.upgradeUrl} target="_blank">
                        {__("Upgrade", "feeds-for-youtube")}
                      </a>
                    </span>
                  </span>
                </div>
              </div>
              <div className="field-right-content">
                <LicenseActionButton
                  isLicenseActive={isLicenseActive}
                  licenseField={licenseFieldRef}
                  setLicenseStatus={setLicenseStatus}
                  setLicenseData={setLicenseData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseSection;
